// extracted by mini-css-extract-plugin
module.exports = {"container":"SurrogateMotherProfile_container__2Ljj5","contents":"SurrogateMotherProfile_contents__2A7kf","title":"SurrogateMotherProfile_title__2UPfM"};